import styled from "grabcad-ui-elements";

export const StyledLabel = styled.label<{ labelFontSize?: number }>`
    font-size: ${({ labelFontSize }) => labelFontSize}px;
    font-weight: 700;
    margin-bottom: 15px;
`;
